export default __webpack_public_path__ + "static/media/downloadIcon.3a64cc4f.svg";